import happy_1 from '../../public/assets/lowRes/1_happy.png';
import happy_2 from '../../public/assets/lowRes/2_happy.png';
import happy_3 from '../../public/assets/lowRes/3_happy.png';
import happy_4 from '../../public/assets/lowRes/4_happy.png';
import happy_5 from '../../public/assets/lowRes/5_happy.png';
import neutral_1 from '../../public/assets/lowRes/1_neutral.png';
import neutral_2 from '../../public/assets/lowRes/2_neutral.png';
import neutral_3 from '../../public/assets/lowRes/3_neutral.png';
import neutral_4 from '../../public/assets/lowRes/4_neutral.png';
import neutral_5 from '../../public/assets/lowRes/5_neutral.png';
import sad_1 from '../../public/assets/lowRes/1_sad.png';
import sad_2 from '../../public/assets/lowRes/2_sad.png';
import sad_3 from '../../public/assets/lowRes/3_sad.png';
import sad_4 from '../../public/assets/lowRes/4_sad.png';
import sad_5 from '../../public/assets/lowRes/5_sad.png';
import { SquashMood } from '@src/data/types';

const moodImages: MoodImages = {
  0: { happy: happy_1, thirsty: neutral_1, sad: sad_1 },
  1: { happy: happy_2, thirsty: neutral_2, sad: sad_2 },
  2: { happy: happy_3, thirsty: neutral_3, sad: sad_3 },
  3: { happy: happy_4, thirsty: neutral_4, sad: sad_4 },
  4: { happy: happy_5, thirsty: neutral_5, sad: sad_5 },
};

type MoodImages = {
  [level: number]: { [mood in SquashMood]: string };
};
export const SquashLowRes = ({
  level,
  mood,
}: {
  level: number;
  mood: SquashMood;
}) => {
  level = Math.min(4, level);
  if (!moodImages[level][mood]) {
    return null;
  }

  return (
    <img
      className='absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 transform'
      src={moodImages[level][mood]}
    />
  );
};
